export default {
  nominalTension: {
    type: Number,
    label: 'fields.asset.circuit-breaker.nominal-tension',
    min: 0.01,
    max: 10000,
    maxLength: 9,
    precision: 2,
  },
  nominalChain: {
    type: Number,
    label: 'fields.asset.circuit-breaker.nominal-chain',
    min: 0.01,
    max: 10000,
    maxLength: 9,
    precision: 2,
  },
  nominalFrequency: {
    type: Number,
    label: 'fields.asset.circuit-breaker.nominal-frequency',
    min: 1,
    max: 100,
    maxLength: 3,
    precision: 0,
  },
  typicalOpeningTime: {
    type: Number,
    label: 'fields.asset.circuit-breaker.opening-time',
    min: 1,
    max: 500,
    maxLength: 3,
    precision: 0,
  },
  maximumClosingTime: {
    type: Number,
    label: 'fields.asset.circuit-breaker.closing-time',
    min: 1,
    max: 500,
    maxLength: 3,
    precision: 0,
  },
  interruptionCapacity: {
    type: Object,
    nominal: {
      type: Number,
      label: 'fields.asset.circuit-breaker.nominal',
      min: 0.01,
      max: 1000,
      maxLength: 8,
      precision: 2,
    },
    continuousChainPercentage: {
      type: Number,
      label: 'fields.asset.circuit-breaker.continuous-chain',
      min: 0,
      max: 200,
      maxLength: 5,
      precision: 1,
    },
  },
  supportableNominalTension: {
    type: Object,
    applied: {
      type: Number,
      label: 'fields.asset.circuit-breaker.applied-voltage',
      min: 0.01,
      max: 10000,
      maxLength: 9,
      precision: 2,
    },
    atmosphericImpulse: {
      type: Number,
      label: 'fields.asset.circuit-breaker.atmospheric-impulse',
      min: 1,
      max: 100000,
      maxLength: 7,
      precision: 0,
    },
    industrialFrequency: {
      type: Number,
      label: 'fields.asset.circuit-breaker.industrial-frequency',
      min: 0.01,
      max: 10000,
      maxLength: 9,
      precision: 2,
    },
  },
};
